import { HexContainer } from '../hex-container/hex-container';
import FaceEnroll from '../../../../assets/face-enroll.svg?react';
import './authentication-header.less';
import { Banner, type BannerProps } from '../../../Banner/banner';

interface AuthenticationHeaderProps {
  hexImage?: React.ReactNode;
  logoUrl?: React.ReactNode;
  banner?: BannerProps;
}

export const AuthenticationHeader = ({
  hexImage = <FaceEnroll />,
  logoUrl,
  banner,
}: AuthenticationHeaderProps) => {
  return (
    <div
      className={`authn-layout-header ${banner && banner.status === 'warning' ? 'warning' : ''}`}
    >
      {banner && <Banner {...banner} className="authentication-banner" />}
      <span className="authn-layout-header-logo">{logoUrl}</span>
      <HexContainer className="authn-layout-header-hex" icon={hexImage} />
    </div>
  );
};
